import { LivretEleve } from 'containers/Livrets/types/livret';
import { LivretEleveDiff } from './types';

export function buildDiffKey(diff: LivretEleveDiff) {
  return `${diff.matiereCode}-${diff.domaineCode}-${diff.competence}-${diff.matiereRemark}`;
}

export function findCurrentNote(
  livretEleve: LivretEleve,
  matiereCode?: string,
  domaineCode?: string,
  competence?: string,
): number | undefined {
  const matiere = livretEleve.matieres?.find(m => m.code === matiereCode);
  if (!domaineCode) {
    if (!competence) {
      return matiere?.note;
    }
    return matiere?.competences?.find(c => c.name === competence)?.note;
  }

  const domaine = matiere?.domaines?.find(d => d.code === domaineCode);
  if (!competence) {
    return domaine?.note;
  }
  return domaine?.competences?.find(c => c.name === competence)?.note;
}

export function findCurrentCompetenceList(
  livretEleve: LivretEleve,
  matiereCode: string,
  domaineCode?: string,
): string[] {
  const matiere = livretEleve.matieres?.find(m => m.code === matiereCode);
  const matiereCompetences = matiere?.competences || [];
  const domaine = matiere?.domaines?.find(d => d.code === domaineCode);
  const domaineCompetences = domaine?.competences || [];

  return [...matiereCompetences, ...domaineCompetences].map(c => c.name);
}
